module.exports = __webpack_public_path__ + "img/09_sc.bc6d6127.png";